import { Trans, useTranslation } from 'react-i18next';
import { Button, Checkbox, Modal, Tooltip } from '@mantine/core';
import { useForm } from '@mantine/form';

import { useAuthContext } from '../../context/AuthContext';
import { CURRENT_REGULATIONS_VERSION } from '../../constants';
import { UpdateRegulations } from '../../types/user';

import styles from './Regulations.module.scss';

interface Form {
  accept: boolean;
  marketing: boolean;
}

const RegulationsModal = () => {
  const { t } = useTranslation();

  const { user, acceptRegulations } = useAuthContext();

  const form = useForm<Form>({
    initialValues: {
      accept: false,
      marketing: false,
    },
    validate: {
      accept: (value: boolean) => (value ? null : t('FIELD_REQUIRED')),
    },
  });

  const submitHandler = (values: Form) => {
    if (!user) return;
    const _data: UpdateRegulations = {
      settings: {
        ...user.settings,
        regulations: 'accepted',
        regulations_version: CURRENT_REGULATIONS_VERSION,
      },
    };
    if (values.marketing) {
      _data.marketing = values.marketing;
    }
    if (_data) {
      acceptRegulations(_data);
    }
  };

  return (
    <Modal
      opened={true}
      onClose={() => {}}
      centered
      withCloseButton={false}
      overlayProps={{ blur: 10 }}
      size={500}
    >
      <form
        onSubmit={form.onSubmit((values) => submitHandler(values))}
        className={styles.regulations}
      >
        <p className="medium-font">{t('REGULATIONS_INFO')}</p>
        <Checkbox
          label={
            <Trans
              i18nKey="common:ACCEPT_REGULATIONS"
              components={{
                a: (
                  <a
                    href="https://ferguson-digital.eu/inteligentny-dom/ferguson-smarthome2-smart_alert-regulations-pl.pdf"
                    target="_blank"
                    rel="noreferrer"
                  ></a>
                ),
              }}
            />
          }
          {...form.getInputProps('accept')}
          required
        />
        {user && !user.marketing && (
          <Tooltip
            label={t('common:NEWSLETTER_TOOLTIP')}
            multiline={true}
            position="bottom"
            style={{ width: 500 }}
          >
            <div>
              <Checkbox
                label={t('common:ACCEPT_NEWSLETTER', { email: user.email })}
                {...form.getInputProps('marketing')}
              />
            </div>
          </Tooltip>
        )}
        <Button type="submit">{t('SUBMIT')}</Button>
      </form>
    </Modal>
  );
};

export default RegulationsModal;
